export default __webpack_public_path__ + "static/media-xs-61fb6e6149b6f024dc2954d51d3dbb3b.png";